import { Requirement } from "../requirements";

export class MetadataTemplate {
	public static readonly $type: string = "MetadataTemplate";
	public readonly $type: string = MetadataTemplate.$type;

	public constructor() {

		this.name = "Data Template";
		this.requirements = [];
	}

	public id?: number;
	public name!: string;
	public requirements!: Requirement[];
}
